// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Message } from './Message';
import { DirectXMLMessage } from './DirectXMLMessage';
import { OperationType } from '../Trading/OperationType';
export class DirectCreateMessage extends DirectXMLMessage {
    constructor() {
        super(Message.CODE_NEW_ORDER_MESSAGE);
        this.DialogId = 0;
        this.OrderId = '';
        this.Symbol = '';
        this.OperationType = OperationType.Buy;
        this.OrderType = 0;
        this.Amount = 0;
        this.Price = 0;
        this.OpenOrderId = null;
        this.BoundToOrderId = null;
        this.AccountID = null;
        this.BstrMarket = null;
        // yura - NewPrice(для модификации Limit ордеров)
        this.NewPrice = 0;
        this.ExpDate = null;
    }
}
